import React, {
  createContext, useContext, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import { useConsentAPI } from 'apiServices/consentAPI';
import { useUserContext } from 'store';
import policyRequests from 'services/policyRequests';
import { toast } from 'react-toastify';
import { ToastMessage } from 'components';

const initialState = null;

export const PrivacyContext = createContext(initialState);

export function PrivacyContextProvider({ children }) {
  const [user] = useUserContext();
  const [isSharing, setIsSharing] = useState(initialState);
  const [privacyLoading, setPrivacyLoading] = useState(false);
  const [consentPolicyResult, consentPolicyError, consentPolicyLoading, consentPolicyRefetch] = useConsentAPI({ patientID: user.username });

  useEffect(() => {
    if (!consentPolicyLoading && !consentPolicyError) {
      setPrivacyLoading(false);
      setIsSharing(consentPolicyResult.politicaRES.toLowerCase().includes('opt-in'));
    }
  }, [consentPolicyLoading, consentPolicyResult]);

  async function denyConsentSharing() {
    setPrivacyLoading(true);
    await policyRequests.setPolicyRequest('Opt-out', user.cpf);
    consentPolicyRefetch();
    toast.success(<ToastMessage type="success">Opção de compartilhamento atualizada.</ToastMessage>);
  }

  async function allowConsentSharing() {
    setPrivacyLoading(true);
    await policyRequests.setPolicyRequest('Opt-in', user.cpf);
    consentPolicyRefetch();
    toast.success(<ToastMessage type="success">Opção de compartilhamento atualizada.</ToastMessage>);
  }

  const contextValue = {
    privacyLoading,
    isSharing,
    denyConsentSharing,
    allowConsentSharing,
  };

  return (
    <PrivacyContext.Provider value={contextValue}>
      {children}
    </PrivacyContext.Provider>
  );
}

export function usePrivacyContext() {
  return useContext(PrivacyContext);
}

PrivacyContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
